import { application } from "../application"

import AjaxContentController from "../ajax_content_controller"
application.register("ajax-content", AjaxContentController)

import FavoriteController from "../favorite_controller"
application.register("favorite", FavoriteController)

import FooterAdController from "../footer_ad_controller"
application.register("footer-ad", FooterAdController)

import RecentlyStocksController from "../recently_stocks_controller"
application.register("recently-stocks", RecentlyStocksController)

import SmoothScrollController from "../smooth_scroll_controller"
application.register("smooth-scroll", SmoothScrollController)

import JsLazyLoadingController from "../js_lazy_loading_controller"
application.register("js-lazy-loading", JsLazyLoadingController)

import FavBtnsController from "../fav_btns_controller"
application.register("fav-btns", FavBtnsController)
